<template>
    <div class="the-page">
        <header v-if="pageTitle || pageSubTitle || $slots.subtitle || $slots.controls || breadcrumbExists">
            <Breadcrumbs v-if="breadcrumbExists"/>
            <div class="columns is-mobile is-vcentered page-heading">
                <div class="column">
                    <h1 class="title" v-text="pageTitle" v-if="pageTitle" />
                    <h2 class="subtitle is-6" v-text="pageSubTitle" v-if="pageSubTitle"/>
                    <h2 class="subtitle is-6" v-else-if="$slots.subtitle"><slot name="subtitle"/></h2>
                    <slot name="addon" />
                </div>
                <div class="column is-narrow has-text-right page-controls" v-if="$slots.controls">
                    <slot name="controls" />
                </div>
            </div>
        </header>
        <div class="page-container">
            <slot />
        </div>
        <div class="page-footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script setup lang="ts">

  import { computed } from "vue";
  import { useRoute } from "vue-router";

  import Breadcrumbs from "@/components/Breadcrumbs.vue";

  const route = useRoute();

  const props = withDefaults(defineProps<{
    fullWidth?: boolean,
    narrow?:  boolean,
    title?: string | false,
    subTitle?: string | false,
  }>(), {
    fullWidth: false,
    narrow:  false,
    title: '',
    subTitle: ''
  });

  const pageTitle = computed(() => {
    if(props.title === false){
      return false;
    }
    return props.title || route.meta.title;
  });

  const pageSubTitle = computed(() => {
    if(props.subTitle === false){
      return false;
    }
    return props.subTitle || route.meta.subTitle;
  });

  const breadcrumbExists = computed(() => {
    return (route.meta && route.meta.breadcrumbs);
  });

</script>
